import { render, staticRenderFns } from "./ActsandRulesCardComponents.vue?vue&type=template&id=661260a6&scoped=true&"
import script from "./ActsandRulesCardComponents.vue?vue&type=script&lang=js&"
export * from "./ActsandRulesCardComponents.vue?vue&type=script&lang=js&"
import style0 from "./ActsandRulesCardComponents.vue?vue&type=style&index=0&id=661260a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661260a6",
  null
  
)

export default component.exports